import React from "react";
import {Typography} from "@mui/material";
import {useSessionContext} from "../../util/SessionContext";

// Right-aligned persona readout for a page's blue title bar (mirrors t1's Project Plan header):
// two white lines — the persona type, then "Type: Name". Renders nothing when no persona is set.
// Drop it into a PageHeader as a child. Shared by the Knowledge Catalog and Enterprise Glossary.

// Per active-visibility Mode: the top-line `label`, the bottom-line `nameLabel` prefix (which entity the
// resolved name is), and the Account array that resolves that name. Mirrors t1's Project Plan header:
// Organization and Management (labeled "Manager") are POSITION-family modes — the visibility Value stays
// the selected Position USID, so the top line shows the mode ("Organization" / "Manager") while the
// bottom line reads "Position: <Position Name>" (nameLabel "Position"), resolved from Positions. For the
// other modes the nameLabel matches the label (e.g. "User Group: <name>").
const PERSONA_MODES: Record<string, {label: string; nameLabel: string; companyKey: "Positions" | "UserGroups" | "WorkGroups"}> = {
    Position: {label: "Position", nameLabel: "Position", companyKey: "Positions"},
    Organization: {label: "Organization", nameLabel: "Position", companyKey: "Positions"},
    Management: {label: "Manager", nameLabel: "Position", companyKey: "Positions"},
    UserGroup: {label: "User Group", nameLabel: "User Group", companyKey: "UserGroups"},
    WorkGroup: {label: "Work Group", nameLabel: "Work Group", companyKey: "WorkGroups"},
};

export function usePersona(): {type: string; nameLabel: string; name: string} | null {
    const sessionContext = useSessionContext();
    const visibility = sessionContext.getActiveVisibility();
    if (!visibility || !visibility.Mode) {
        return null;
    }
    const mode = PERSONA_MODES[visibility.Mode];
    if (!mode) {
        return null;
    }
    const account: any = sessionContext.getAccount();
    const match = (account?.[mode.companyKey] ?? []).find((entry: any) => entry.USID === visibility.Value);
    return {type: mode.label, nameLabel: mode.nameLabel, name: match?.Name ?? ""};
}

// When the type IS the name's label (Position, User Group, Work Group) the top line would only repeat the
// bottom one's prefix, so a single line "Position: <Name>" is shown instead.
export default function PersonaHeaderInfo() {
    const persona = usePersona();
    if (!persona) {
        return null;
    }
    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            {persona.type !== persona.nameLabel &&
                <Typography style={{fontSize: 14, fontWeight: 400, color: "#FFFFFF"}}>{persona.type}</Typography>}
            <Typography style={{fontSize: 14, fontWeight: 400, color: "#FFFFFF"}}>{persona.nameLabel}: {persona.name}</Typography>
        </div>
    );
}
